import groupIcon from '../assets/group.svg';
import bedIcon from '../assets/bed.svg';
import bathIcon from '../assets/bath.svg';
import card1Image from '../assets/home/card1.png';
import card2Image from '../assets/home/card2.png';
import card3Image from '../assets/home/card3.png';
import card4Image from '../assets/home/card4.jpg';
import card5Image from '../assets/home/card5.png';

export const bookingProperties = [
  {
    image: card1Image,
    title: 'Apartments',
    subtitle: '789 Sunset Boulevard, LA 90028',
    price: '5.000',
    currency: 'AED',
    chips: [
      { icon: groupIcon, text: '2 beds' },
      { icon: bedIcon, text: '2 beds' },
      { icon: bathIcon, text: '2 baths' },
    ],
  },
  {
    image: card2Image,
    title: 'Luxury 2BR | Skyline View',
    subtitle: 'Between DIFC & Downtown',
    price: '1.500',
    currency: 'AED',
    chips: [
      { icon: groupIcon, text: '4 beds' },
      { icon: bedIcon, text: '4 beds' },
      { icon: bathIcon, text: '3 baths' },
    ],
  },
  {
    image: card3Image,
    title: 'Modern Spacious 2BR',
    subtitle: 'Stunning Burj Khalifa View',
    price: '2.000',
    currency: 'AED',
    chips: [
      { icon: groupIcon, text: '12 guests' },
      { icon: bedIcon, text: '2 beds' },
      { icon: bathIcon, text: '2.5 baths' },
    ],
  },
  {
    image: card4Image,
    title: 'Luxury Loft Near Downtown Dubai',
    subtitle: 'Downtown Dubai',
    price: '1.000',
    currency: 'AED',
    chips: [
      { icon: groupIcon, text: '2 beds' },
      { icon: bedIcon, text: '2 beds' },
      { icon: bathIcon, text: '2 baths' },
    ],
  },
  {
    image: card5Image,
    title: 'Townhouse',
    subtitle: '2345 Main Street, Boston 02101',
    price: '9.200',
    currency: 'AED',
    chips: [
      { icon: groupIcon, text: '5 people' },
      { icon: bedIcon, text: '5 beds' },
      { icon: bathIcon, text: '4 baths' },
    ],
  },
];

